import {Action} from 'redux'
import {LeadFormModel} from '../Model'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

const initialLeadFormDetailState: ILeadFormDetailState = {
  data: {
    leadForm: [],
    meta: [],
  },
  loading: false,
  success: false,
}

export interface ILeadFormDetailState {
  data?: {
    leadForm?: LeadFormModel[]
    meta?: {[key: string]: string | number}[]
  }

  loading?: boolean
  success?: boolean
}

export const reducer = (
  state: ILeadFormDetailState = initialLeadFormDetailState,
  action: ActionWithPayload<ILeadFormDetailState>
) => {
  switch (action.type) {
    case actionTypes.GET_LEAD_FORM_DETAIL_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_LEAD_FORM_DETAIL_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_LEAD_FORM_DETAIL_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.EXPORT_LEAD_FORM_DETAIL_FILE_START: {
      return {...state, loading: true}
    }

    case actionTypes.EXPORT_LEAD_FORM_DETAIL_FILE_SUCCESS: {
      return {...state, success: true, loading: false}
    }

    case actionTypes.EXPORT_LEAD_FORM_DETAIL_FILE_FINISH: {
      const error = action.payload
      return {...state, error, success: false, loading: false}
    }

    default:
      return state
  }
}
